import { render, staticRenderFns } from "./DownlineDetail.vue?vue&type=template&id=452f6a6a"
import script from "./DownlineDetail.vue?vue&type=script&lang=js"
export * from "./DownlineDetail.vue?vue&type=script&lang=js"
import style0 from "./DownlineDetail.vue?vue&type=style&index=0&id=452f6a6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports